var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('div',{staticClass:"segments"},[(_vm.item.segments.length)?_vm._l((_vm.item.segments),function(segment,index){return _c('div',{key:index},[_vm._v(_vm._s(segment.name))])}):_c('span',[_vm._v("-")])],2)]),_c('td',[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('td',[(
        _vm.$userCheckAccess({
          abilities: 'edit_project_types',
        })
      )?_c('div',{staticClass:"buttons"},[_c('ProjectTypeModal',{attrs:{"id":_vm.item.id}}),_c('DeleteModal',{attrs:{"item":_vm.item,"text":_vm.localStorage.translations.pages['setting-project_type']['dialog-delete'][
            'udalit-tip-proekta'
          ] +
          ' ' +
          _vm.item.name}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }